import React, { useEffect, useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const AllArtists = () => {
  const [artists, setArtists] = useState([]);
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);

  function goBack() {
    window.history.back();
  }

  useEffect(() => {
    const fetchArtists = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }
      if (localStorage.getItem('artists')) {
        setArtists(JSON.parse(localStorage.getItem('artists')));
        return;
      }

      try {
        const response = await fetchWithAuth(
          `${API_ENDPOINTS.ARTISTS}?limit=20`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json(); // try to parse the error message
          const errorMsg =
            errorData?.message || errorData?.error || 'Something went wrong';
          setErrorMsg(errorMsg.toString());
          setIsError(true);
          // alert(`HTTP ${response.status}: ${errorMsg}`);
        }

        const data = await response.json();
        setArtists(data.artists);
        localStorage.setItem('artists', JSON.stringify(data.artists));
      } catch (error) {
        console.error('Error fetching songs:', error);
        // setErrorMsg(error);
        // setIsError(true);
      }
    };

    fetchArtists();
  }, []);
  useEffect(() => {
    if (isError) {
      const timeout = setTimeout(() => {
        cancelMsg(); // Set isError to false
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [isError]);

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  const navigatArtist = id => {
    navigate(`/artist?aid=${id}`);
  };

  const cancelMsg = () => {
    setIsError(false);
  };

  return (
    <div
      className="d-flex flex-column align-items-center px-2 position-relative"
      style={{ height: '100dvh' }}
    >
      {isError && (
        <div
          style={{
            position: 'fixed',
            bottom: '80px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            color: 'white',
            background: 'rgba(236, 236, 236, 1)',
            borderRadius: '20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.32)',
            padding: '16px 24px',
            minWidth: '300px',
            maxWidth: '90vw',
            animation: 'slideDown 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <img
            src="/images/logo.svg"
            style={{
              width: '18px',
              height: '18px',
              flexShrink: 0,
            }}
          />
          <div
            style={{
              color: 'black',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            {typeof errorMsg === 'string'
              ? errorMsg
              : errorMsg?.message || 'Something went wrong'}
          </div>
        </div>
      )}

      <div
        className="d-flex flex-row align-items-center w-100 mb-2 mt-3"
        style={{
          color: '#D0151C',
          background: 'linear-gradient(90deg, #641FAA 0%, #8A325D 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        <IoIosArrowBack
          className="mt-1"
          style={{ fontSize: '22px', marginRight: '10px', color: '#8A325D' }}
          onClick={() => goBack()}
        />
        <h2 className="m-0">Popular Artists</h2>
      </div>

      {/* <div
        className="d-flex flex-row align-items-center px-2 py-1 mb-2 w-100"
        style={{
          gap: "15px",
          borderRadius: "10px",
          border: "1px solid #C3C0C0",
          fontSize: "20px",
        }}
      >
        <IoSearchOutline className="mt-1" />
        <input
          type="text"
          style={{ border: "none", background: "transparent", outline: "none" }}
          placeholder="Search for a artist..."
          className=" text-start"
        />
      </div> */}

      <div
        className="d-flex flex-wrap align-items-start justify-content-start w-100 overflow-scroll"
        style={{ scrollBehavior: 'smooth', gap: 0 }}
      >
        {artists?.length === 0 ? (
          <span>Loading Artists...</span>
        ) : (
          <div className="w-100 d-flex flex-wrap align-items-start justify-content-start">
            {artists?.map((item, index) => (
              <button
                key={index}
                className="col-4 overflow-hidden"
                style={{
                  border: 'none',
                  background: 'transparent',
                  padding: 10,
                }}
                onClick={() => navigatArtist(item?.id)}
              >
                <img
                  className="w-100"
                  src={item?.images[0]?.url}
                  style={{
                    borderRadius: '50%',
                    aspectRatio: '1/1',
                    filter: 'brightness(0.9)',
                  }}
                />
                <span
                  className="text-start w-100"
                  style={{
                    color: 'black',
                    fontSize: 'clamp(0px,3.5vw,15px)',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {item?.name}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AllArtists;
